import ShoppingAnimation from './shopping_animation'

export default ShoppingAnimation
